import * as Sentry from "@sentry/react";
import { createAction, createAsyncAction } from "@dpdgroupuk/redux-action-creator";
import { ACTIONS } from "./AppActionTypes";
import { UserSessionDataActions } from "../Redux";
export const getAppUser = createAsyncAction(apis => async () => {
  const {
    data
  } = await apis.auth.getCurrentUser();
  Sentry.setUser(data);
  return data;
}, ACTIONS.FETCH_APP_USER);
export const clearUser = () => createAction(ACTIONS.CLEAR);
export const clearAppUserData = () => dispatch => {
  dispatch(UserSessionDataActions.clearAll());
  dispatch(clearUser());
};